export default "__VITE_ASSET__JnxO2S2y__"